import Layout from "../components/Layout";

export default function Home() {
  return <Layout>smh</Layout>;
}
